import { ReactNode } from 'react';
import { RiLock2Fill } from 'react-icons/ri';
import Tooltip from '@/components/UI/Tooltip';
import type { DataTableColumnType } from '@/components/UI/DataTableV2/DataTable.model';
import { DataTableColumnTypeIcon } from './DataTableColumnTypeIcon';
import styles from '../DataTableV2.module.scss';

interface DataTableColumnTypeSymbolProps {
  type: DataTableColumnType;
  locked?: boolean;
  tooltip?: ReactNode;
  testId?: string;
}

export function DataTableColumnTypeSymbol({
  type,
  locked = false,
  tooltip,
  testId = 'column-type-symbol',
}: DataTableColumnTypeSymbolProps): JSX.Element {
  const symbolElement = (
    <span className={`flex ${styles.columnTypeSymbolContainer}`} style={{ position: 'relative' }} data-testid={testId}>
      <div className={styles.columnTypeSymbol}>
        <DataTableColumnTypeIcon type={type} />
      </div>
      {locked && <RiLock2Fill size={12} fill="#ff8d02" className={styles.columnTypeLockSymbol} />}
    </span>
  );

  if (tooltip) {
    return <Tooltip render={tooltip}>{symbolElement}</Tooltip>;
  }

  return symbolElement;
}
